import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

import { GameSetup, gameBalanceSheet, balanceSheetDetail, year, shape, point, sectorObject, sectorHolder, sectorCurves, gameSectors, yearEndChart, yearEndPerformance, timerSettings, gameSummary } from './game';
import { Globals } from './globals'
import { GameComponentService } from './gameComponent.service';
import { Subscription }   from 'rxjs/Subscription';

@Injectable()
export class FutureShape {
    public Setup: GameSetup; 

    public yearIndex: number;
    public timeLimit: number;
    public gameOver: boolean = true;
    ////public sectorDefinition:Object;
    public showBloomBerg:boolean;
    public whichTRA: number;
    public whichTRE: number;
    public sectorIDArray:string[];
    public gameData: gameSectors[];    
    public gameDataOld: number[]; //for limit validation
    public sectorTotal: number;
    public sectorTotalOld: number;

    public sectorObj:sectorObject;
    public sectorPoints:sectorCurves[];
    public sectorIDsHolder:sectorHolder[];
    public BankBalanceSheet: gameBalanceSheet[];
    public TypicalBankBalanceSheet: gameBalanceSheet[];
    //public newShape:Array;
    public capRatio: number;
    public advanceShapeArray:number[]; 
    public highBonds: number;
    public lowBonds: number;
    public leverageX: number;
    public curveNames:string[]; //Yield Curve Chart
    public curveNumbers:number[]; //Yield Curve Chart
    public oldCurve:number[];
    public yieldCurveArray:number[][];
    public YieldNameArray:string[][];
    public sectorNames:string[];
    public yearEquity: number;
    public lastYearEquity: number;
    public bondPortfolio: number;
    public myTRE: number;
    public typicalEquity: number;
    public lastYearTypicalEquity: number;
    public typicalBondPortfolio: number;
    public typicalTRE: number;
    public newCapRatio: number;
    public newCapPct: number;    
    public OriginalBonds: number;
    
    private dataIn:Boolean = false; 
    private _globals:Globals;
    private years: number;
    
    private myBankShape:number[];
    private typicalBankShape:number[];
    private calcShape:number[];
    private newShape:number[];
    private typicalBank:number[];
    private sliderArray:number[];
    private sliderUpdated:boolean;
    
    private whichGame: number;

    public currentGame_Active: boolean = true;
    public currentGame_Sector_Allocation_Title: string;
    public currentGame_Assets_Bonds: number;
    public currentGame_Assets_Loans: number;
    public currentGame_Assets_Total: number;
    public currentGame_Liabilities_Advances: number;
    public currentGame_Liabilities_Deposits: number;
    public currentGame_Liabilities_Total: number;
    public currentGame_Equity_Liabilities: number;
    public currentGame_Equity_Total: number;

    public sectorSelectedName: string;
    public sectorSelectedDesc: string;
    public sectorSelectedPro: string;
    public sectorSelectedCon: string;    
    public sectorSelectedIndex: number;
    public sectorSelectedImg: string;
    private _sectorSelectedID: number; //private variable for the public get/set
    public get sectorSelectedID(): number {
        return this._sectorSelectedID;
    }
    public set sectorSelectedID(value) {
        this._sectorSelectedID = value;
        var tmpID:string;
        if (!value || value === 0 || this.whichTRA != 1) {
            tmpID = "blank.jpg";
        }
        else {
            tmpID = value.toString() + ".jpg"
        }

        this.sectorSelectedImg = "./assets/img/bonds/" + tmpID;
    }


    public TRA_Title:string;
    public chart_categoryNames: string[];
    public chart_legend_myBank: string;
    public chart_legend_typical: string;
    public chart_legend_bond: string;
    public chart_data_myBank: number[];
    public chart_data_typical: number[];
    public chart_data_bond: number[];    

    public chart_yAxisLabel:string;
    public chart_yAxisMin: number;
    public chart_yAxisMax: number;

    public infoOverlay_chartData: yearEndChart[];
    public infoOverlay_performanceYours: yearEndPerformance;
    public infoOverlay_PerformanceBank: yearEndPerformance;

    public infoOverlay_chart_legend: string[];
    public infoOverlay_chart_categoryNames: string[];
    // public infoOverlay_chart_year1: number[];
    // public infoOverlay_chart_year2: number[];
    // public infoOverlay_chart_year3: number[];
    public infoOverlay_chart: number[][];

    public TRE_data_myBank: number[];
    public TRE_data_typical: number[];

    public endGameSummary: gameSummary[];
    
    private resetGame() {
        console.log("futureShape : resetGame");
        this.Setup = null; 
        this.yearIndex = 0;
        this.timeLimit = 0;
        this.gameOver = false;
        this.showBloomBerg = false;
        this.whichTRA = 0;
        this.whichTRE = 0;
        this.sectorIDArray = [];
        this.gameData = [];    
        this.gameDataOld = []; //for limit validation
        this.sectorTotal = 0;
        this.sectorTotalOld = 0;

        this.sectorObj = null;
        this.sectorPoints = [];
        this.sectorIDsHolder = [];
        this.BankBalanceSheet = [];
        this.TypicalBankBalanceSheet = [];
        //this.newShape =Array;
        this.capRatio = 0;
        this.advanceShapeArray = []; 
        this.highBonds = 0;
        this.lowBonds = 0;
        this.leverageX = 0;
        this.oldCurve = [];
        this.yieldCurveArray = [];
        //this.YieldNameArray = [];
        this.sectorNames = [];
        this.yearEquity = 0;
        this.lastYearEquity = 0;
        this.bondPortfolio = 0;
        this.myTRE = 0;
        this.typicalEquity = 0;
        this.lastYearTypicalEquity = 0;
        this.typicalBondPortfolio = 0;
        this.typicalTRE = 0;
        this.newCapRatio = .10;
        this.newCapPct = 50;
        this.OriginalBonds = 0;
        
        this.dataIn = false; 
        this.years = 0;
        
        this.myBankShape = [];
        this.typicalBankShape = [];
        this.calcShape = [];
        this.newShape = [];
        this.typicalBank = [];
        this.sliderArray = [];
        this.sliderUpdated = false;
        
        this.whichGame = 0;

        //this.currentGame_Active = true;
        this.currentGame_Sector_Allocation_Title = "";
        this.currentGame_Assets_Bonds = 0;
        this.currentGame_Assets_Loans = 0;
        this.currentGame_Assets_Total = 0;
        this.currentGame_Liabilities_Advances = 0;
        this.currentGame_Liabilities_Deposits = 0;
        this.currentGame_Liabilities_Total = 0;
        this.currentGame_Equity_Liabilities = 0;
        this.currentGame_Equity_Total = 0;

        this.sectorSelectedName = "";
        this.sectorSelectedDesc = "";
        this.sectorSelectedPro = "";
        this.sectorSelectedCon = "";    
        this.sectorSelectedIndex = 0;
        this.sectorSelectedID = 0;


        this.TRA_Title = "";
        /*this.chart_categoryNames = [];
        this.chart_legend_myBank = "";
        this.chart_legend_typical = "";
        this.chart_legend_bond = "";
        this.chart_data_myBank = [];
        this.chart_data_typical = [];
        this.chart_data_bond = [];

        this.chart_yAxisLabel ="";*/

        this.infoOverlay_chartData = [];
        this.infoOverlay_performanceYours = null;
        this.infoOverlay_PerformanceBank = null;

        this.infoOverlay_chart_legend = [];
        this.infoOverlay_chart_categoryNames = [];
        this.infoOverlay_chart = [];

        this.TRE_data_myBank = [];
        this.TRE_data_typical = [];

        //this.endGameSummary = null;
        //this._srvc.resetService();
        this._srvc.GameOver(this.gameOver);
        this._srvc.StartGame(false);

    }

    constructor(private http: Http, private _srvc: GameComponentService) {

        //checkDBD();
        this._globals = new Globals();
        //_dataHolder = new DataHolder();

        //default for testing
        //this.loadSetup(1);
        
        ////reads the directory to see how many games
        //getNumberOfGames();
        
        //disclaimerMc.visible = false;
        //disclaimerMc.closeMc.buttonMode = true;
        //disclaimerMc.closeMc.addEventListener(MouseEvent.CLICK, onCloseDiscolosureClick);

        /// TEMP HACK!!!!!!!
        ///
        // this.currentGame_Assets_Bonds = 0;
        // this.currentGame_Assets_Loans = 0;
        // this.currentGame_Assets_Total = 0;
        // this.currentGame_Liabilities_Advances = 0;
        // this.currentGame_Liabilities_Deposits = 0;
        // this.currentGame_Liabilities_Total = 0;
        // this.currentGame_Equity_Liabilities = 0;
        

        ///
        ///
	}

//starts loading data for the game//-----------------------------------------------------------------------------------------------------------------------------------------------------
	loadSetup(gameNum: number) {
		console.log('futureShape : loadSetup : Start');
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc).showLoading();
        ////////////////////////////////////////

        this.whichGame = gameNum;
        this.yearIndex = 0;

        console.log('futureShape : this.whichGame : ' + this.whichGame);
        console.log('futureShape : this.dataIn : ' + this.dataIn);
        
        
        if(this.dataIn){
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.endYearMc.removeOldAssets());
            //MovieClip(gameHolderMc.gameMc.assetAllocationMc.removeOldAssets());
            //MovieClip(gameHolderMc).restartGame();
            
            //Commented out these two lines.
            //Caused the app to not load data int he right order.
            //The graphs did not get the data in time before the view rendered.
            //The page does work on refresh, but not when you click between games.

            //this._srvc.resetService();
            this.resetGame();
            
            ////////////////////////////////////////
        }
        
        this.dataIn=false;

        console.log('futureShape : loadSetup : End');
		return new Promise((resolve, reject) => {
			this.http.get(`./assets/data/game` + gameNum + `.json`)
			.map(res => res.json())
            .catch((error: any) => {
			      console.error(error);
			      return Observable.throw(error.json().error || 'Server error');
		    })
			.subscribe((env_data) => {
                console.log('futureShape : loadSetup : Promise : Return');
			    this.Setup = env_data;
                ////////////////////////////////////////
                //MovieClip(gameHolderMc).removeLoading();
                //MovieClip(gameHolderMc).lockGame();
                ////////////////////////////////////////
                this.dataIn = true;

			    console.log('config loaded');
			    console.log(this.Setup);
                
                //initialize first year
                this.yearIndex = 0;
                this.setUpTimer(); 
                this.gameOver = false;
                this._srvc.GameOver(this.gameOver);
                
                this.sliderArray = new Array(0, 0, 0, 0, 0, 0);
                
                this.getScreens();
                this.BankBalanceSheet = [];
			    this.createBalanceSheet(this.BankBalanceSheet);
			    this.TypicalBankBalanceSheet = [];
			    this.createBalanceSheet(this.TypicalBankBalanceSheet);
			    this.loadBalanceSheet(this.yearIndex);
                console.log(this.BankBalanceSheet);

                this.getSectorInfo();
                        
                this.setUpYieldCurve();
                this.setUpAssets();
                //this.setUpAdvancesShape();

                this.infoOverlay_performanceYours = {
                    Bond: 0,
                    TRE: 0,
                    From: 0,
                    NewEquity: 0,
                    Diff: 0
                };
                this.infoOverlay_PerformanceBank = this.infoOverlay_performanceYours;
                this._srvc.SetPerformance(this.infoOverlay_performanceYours, this.infoOverlay_PerformanceBank);
                this._srvc.SetFooter(false);
                
                ////////////////////////////////////////
                //MovieClip(gameHolderMc.endOverlayMc).clearGrid();
                ////////////////////////////////////////
                this.infoOverlay_chart_legend = ["","",""];
                this.infoOverlay_chart = [];
                this.endGameSummary = [];            


			    /* //if need to load another file
			    this.http.get('/assets/data/' + env_data.env + '.json')
			     
			    .map(res => res.json())

			    .catch((error: any) => {
			      console.error(error);
			      return Observable.throw(error.json().error || 'Server error');
			    })

			    .subscribe((data) => {
			      this._config = data;
			      resolve(true);
			    });*/
			    resolve(true);
			});
		});
	}


    /*
    private function checkDBD():void
    {
        loader = new URLLoader();  

        loader.dataFormat = URLLoaderDataFormat.VARIABLES; 
        loader.addEventListener(Event.COMPLETE, getDBD);  
        loader.load(new URLRequest("dbd.txt"));  
    }
    private function getDBD(event:Event):void
    {
        var dbdDate:Date = new Date(loader.data.date);
        var dtCurrent:Date = new Date();
        trace(dbdDate);
        
        if (dbdDate <= dtCurrent) {
            trace("DEAD");
            MovieClip(gameHolderMc).showDBDAlert("The trial version of the Future Shape game has expired. Please contact Performance Trust for a full version.");
        }
    }
    private function onCloseDiscolosureClick(event:MouseEvent):void
    {
        TweenMax.to(disclaimerMc, .5, { autoAlpha:0});
    }
    public function showDisclosesure():void
    {
        disclaimerMc.visible = true;
        disclaimerMc.alpha = 0;
        TweenMax.to(disclaimerMc, .5, { autoAlpha:1});
    }*/

    
//determines which screens to show//-----------------------------------------------------------------------------------------------------------------------------------------------------
    public getScreens():void
    {
        this.whichTRA = Number(this.Setup.Year[this.yearIndex].TRAType);
        this.whichTRE = Number(this.Setup.Year[this.yearIndex].TREType);
        if(this.whichTRE == 4){
            this.setUpLeverage();
        }
    };
    
//set up box Total Return on Equity//-----------------------------------------------------------------------------------------------------------------------------------------------------
    public updateReturnsBroker(whichID:number)        
    {            
        // var sectorDefinitions:number = this.Setup.SectorDefinition.length;
        // var brokerDefinitions:string[] = [];            
        // var brokerTitles:string[] = [];            
        // for(var i:number = 0; i<sectorDefinitions; i++){                
        //     brokerDefinitions.push(this.Setup.SectorDefinition[i].Desc);                
        //     brokerTitles.push(this.Setup.SectorDefinition[i].Name);            
        // }    
        
        this.sectorSelectedPro = this.sectorSelectedCon = "";
        if (whichID < 0) {
            this.sectorSelectedName = this._globals.brokerDefaultName;
            this.sectorSelectedDesc = ""; // this._globals.brokerDefaultDesc; - removed and moved into welcome screen
        }
        else {
            this.sectorSelectedName = this.Setup.SectorDefinition[whichID].Name
            this.sectorSelectedDesc = this.Setup.SectorDefinition[whichID].Desc;
        }

        ////////////////////////////////////////
        ////MovieClip(gameHolderMc.gameMc.helpMc.showBroker(brokerDefinitions[whichID], brokerTitles[whichID]));        
        //this.showBroker(this.sectorSelectedDesc, this.sectorSelectedName);
        ////////////////////////////////////////
    }      
            
    public updateReturnsProCon(whichID: number)
    {            
        // var sectorDefinitions: number;
        // sectorDefinitions = this.Setup.SectorDefinition.length;
        // var proConDefinitions:string[] = [];           
        // var proConTitles:string[] = [];
        // for(var i:number = 0; i<sectorDefinitions; i++){           
        //     proConDefinitions.push(this.Setup.SectorDefinition[i].Desc);                
        //     proConTitles.push(this.Setup.SectorDefinition[i].Name);            
        // }
        
        if (whichID < 0) {
            this.sectorSelectedName = this._globals.brokerDefaultName;
            this.sectorSelectedDesc = ""; // this._globals.brokerDefaultDesc; - removed and moved into welcome screen
        }
        else {
            var sentence:string = this.Setup.SectorDefinition[whichID].Desc;
            //console.log(sentence);
            //console.log(sentence.split("~")[0]);
            
            var pro:string = sentence.split("~")[0];            
            var con:string = sentence.split("~")[1];

            this.sectorSelectedName = this.Setup.SectorDefinition[whichID].Name;
            this.sectorSelectedDesc = "";
            this.sectorSelectedPro = pro
            this.sectorSelectedCon = con;
        }

        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.helpMc.showProCon(pro, con, proConTitles[whichID]));
        ////////////////////////////////////////
    };
    
    public updateReturnsGraph(leverage:boolean)
    {
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.helpMc.updateChart(leverage));
        ////////////////////////////////////////
    }
//updates year in document class//-----------------------------------------------------------------------------------------------------------------------------------------------------
    public nextYear()
    {
        var tempTRE: number;
        var tempBankTRE: number;
        var tempBondPortfolio: number;
        var tempTypicalBondPortfolio: number;
        
        tempTRE = this.myTRE;
        tempBankTRE = this.typicalTRE;
        //trace(typicalTRE);
        tempBondPortfolio = this.bondPortfolio;
        tempTypicalBondPortfolio = this.typicalBondPortfolio;
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.helpMc.setSlider());
        ////////////////////////////////////////
                    
        var yearsActual:string[] = [];
        for(var i:number = 0; i< this.years; i++){
            yearsActual.push(this.Setup.Year[i].Actual);
        }
        var gameLength: number = Number(this.Setup.NumberOfYearsToPlay);			
        this.updateBalanceSheet(this.yearIndex);
        console.log("gameLength = " + gameLength);
        if (gameLength == 1) {
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.endOverlayMc).populateEndYield(this.curveNumbers, this.curveNames, this.yearIndex, true);
            this.populateEndYield(this.curveNames, this.yearIndex, true);
            ////////////////////////////////////////
        }
        else {
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.endOverlayMc).populateEndYield(this.curveNumbers, this.curveNames, this.yearIndex, false);
            this.populateEndYield(this.curveNames, this.yearIndex, false);
            ////////////////////////////////////////            
        }
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc).openOverLay();
        ////////////////////////////////////////
        this._srvc.SetFooter(true);
        
        this.lastYearEquity = this.BankBalanceSheet[this.yearIndex].Equity.Balance;
        this.lastYearTypicalEquity = this.TypicalBankBalanceSheet[this.yearIndex].Equity.Balance;
        
        var percentile: number = this.Setup.Year[this.yearIndex].Benchmark.BTR;
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.endYearMc).setYears(this.years, yearsActual, this.yearIndex, tempBondPortfolio, this.typicalBondPortfolio, percentile);
        this.setYears(this.years, yearsActual, this.yearIndex, tempBondPortfolio, this.typicalBondPortfolio, percentile);
        ////////////////////////////////////////
        this.yearIndex++;
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc).openEndYear();
        ////////////////////////////////////////
        if(this.yearIndex >= gameLength){
            this.loadBalanceSheet(this.yearIndex - 1);
            this.endGame();
        }else{
            this.getScreens();
            if (this.whichTRA == 4) {
                this.setUpAdvancesShape();
            }
            this.getSectorInfo();
            this.setUpLeverage();
            this.setUpTimer();
        }
        
        this.setUpYieldCurve();		
        
        if(!tempBondPortfolio) tempBondPortfolio = 0;
        if (!tempTRE) tempTRE = 0;
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.endOverlayMc).setYourPerformance(tempBondPortfolio, tempTRE, this.lastYearEquity, this.yearEquity);
        //MovieClip(gameHolderMc.endOverlayMc).setBankPerformance(tempTypicalBondPortfolio, tempBankTRE, this.lastYearTypicalEquity, TypicalEquity);
        this.setYourPerformance(tempBondPortfolio, tempTRE, this.lastYearEquity, this.yearEquity);
        this.setBankPerformance(tempTypicalBondPortfolio, tempBankTRE, this.lastYearTypicalEquity, this.typicalEquity);
        this._srvc.SetPerformance(this.infoOverlay_performanceYours, this.infoOverlay_PerformanceBank);
        ////////////////////////////////////////
        this.calcTRE();
    };
    private endGame()
    {
        ////////////////////////////////////////
        //MovieClip(gameHolderMc).endGame();
        ////////////////////////////////////////
        this.gameOver = true;
        this._srvc.GameOver(this.gameOver);
        this._srvc.SetTimer({Length: 0, From: 100, To: 100, Year: "End"});

        /*
        endYearMc.visible = true;
        endOverlayMc.visible = true;
        endOverlayMc.shelfUp = true;
        
        endOverlayMc.downEndabled = false;
        MovieClip(endOverlayMc).disableCursor(true);
        
        lockGameVisible();
        TweenMax.to(beginOverlay, 1, {alpha:0, ease:Quint.easeOut});
        
        TweenMax.to(bloombergCTA, 1, {x:-336.9, ease:Quint.easeOut});
        TweenMax.to(endYearMc, 1, {x:7 ,ease:Quint.easeOut});
        TweenMax.to(gameMc, 1, {x:-1013 ,ease:Quint.easeOut});
        */
    }

//sets up game inputs//-----------------------------------------------------------------------------------------------------------------------------------------------------
    public getSectorInfo()
    {
        console.log("getSectorInfo");

        var sectors:number = this.Setup.Year[this.yearIndex].Sector.length;        
        var oldGameData = this.gameData; //save old values to repopulate
        this.gameData = [];
        this.sectorTotal = 0;
        this.sectorSelectedID = null;
        this.sectorSelectedName = "(select from left)";
        
        var sectorYield:number[] = [];
        var sectorDuration:number[] = [];
        var sectorID:number;
        this.sectorNames = [];
        var sectorTypicalBank:number[] = [];
        var sectorCurveShape:point[][] = [];
        var sectorCurveDA:number[] = [];
        var sectorCurveDM:number[] = [];
        var sectorCurveUC:number[] = [];
        var sectorCurveUM:number[] = [];
        var sectorCurveUA:number[] = [];
        var sectorCurveActual:number[] = [];
        this.sectorIDArray = [];
        //sectorShapePoints = new Array;
        this.sectorObj;
        this.sectorPoints = [];
        this.sectorIDsHolder = [];
        
        var typicalDA:number[] = [];
        var typicalDM:number[] = [];
        var typicalUC:number[] = [];
        var typicalUM:number[] = [];
        var typicalUA:number[] = [];
        var typicalActual:number[] = [];
        this.yieldCurveArray = new Array();
        
        var tda: number = 0;
        var tdm: number = 0;
        var tuc: number = 0;
        var tum: number = 0;
        var tua: number = 0;
        var tactual: number = 0;
        
        this.YieldNameArray = [];
        var numOfYears: number = this.years;
        if(this.years == 1){
            numOfYears = 2;
        }
        
        for(var i:number = 0; i<numOfYears; i++){
            var nameArray:string[] = [];
            var itemArray:number[] = [];
            for(var j:number = 0; j<8; j++){
                itemArray.push(Number(this.Setup.Year[i].YieldCurve.Point[j].Text));
                nameArray.push(this.Setup.Year[i].YieldCurve.Point[j].Name);
            }
            this.YieldNameArray.push(nameArray);
            this.yieldCurveArray.push(itemArray);
            
            //console.log("nameArray");
            //console.log(nameArray);
            //console.log("itemArray");
            //console.log(itemArray);
        }

        
        
        for(i=0; i<sectors;i++){
            sectorYield.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Yield));
            sectorDuration.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Duration));
            this.sectorIDArray.push(this.Setup.Year[this.yearIndex].Sector[i].ID);
            sectorID = Number(this.Setup.Year[this.yearIndex].Sector[i].ID);
            this.sectorNames.push(this.Setup.SectorDefinition.find(item => item.ID == sectorID).Name);
            
            sectorTypicalBank.push(Number(this.Setup.Year[this.yearIndex].Sector[i].TypicalAllocation));
            sectorCurveShape.push(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point);
            sectorCurveDA.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point.find((item => item.Name == "DA")).Text));
            sectorCurveDM.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point.find((item => item.Name == "DM")).Text));
            sectorCurveUC.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point.find((item => item.Name == "UC")).Text));
            sectorCurveUM.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point.find((item => item.Name == "UM")).Text));
            sectorCurveUA.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.Point.find((item => item.Name == "UA")).Text));
            sectorCurveActual.push(Number(this.Setup.Year[this.yearIndex].Sector[i].Shape.ActualBTR));
            
            typicalDA.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveDA[i]));
            typicalDM.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveDM[i]));
            typicalUC.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveUC[i]));
            typicalUM.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveUM[i]));
            typicalUA.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveUA[i]));
            typicalActual.push(Number((sectorTypicalBank[i]/100))*Number(sectorCurveActual[i]));
            
            //default to 0, but look for old sector and set new one to old value
            var oldSectorVal:number = 0;
            if (oldGameData) {
                var oldSector = oldGameData.find(item => item.ID == this.Setup.Year[this.yearIndex].Sector[i].ID);
                if (oldSector) {
                    oldSectorVal = oldSector.GameValue;
                }
            }

            //populates the sliders
            var tempData: gameSectors = {
                "Index": i,
                "ID": this.Setup.Year[this.yearIndex].Sector[i].ID,
                "Name": this.Setup.SectorDefinition.find(item => item.ID == sectorID).Name,
                "Yield": Number(this.Setup.Year[this.yearIndex].Sector[i].Yield),
                "Duration": Number(this.Setup.Year[this.yearIndex].Sector[i].Duration),
                "TypicalAllocation": Number(this.Setup.Year[this.yearIndex].Sector[i].TypicalAllocation),
                "GameValue": oldSectorVal
            };
            this.gameData.push(tempData);

            //console.log("tempData");
            //console.log(tempData);
        }
        for(i=0; i<sectors; i++){
            tda = Number(typicalDA[i])+tda;
            tdm = Number(typicalDM[i])+tdm;
            tuc = Number(typicalUC[i])+tuc;
            tum = Number(typicalUM[i])+tum;
            tua = Number(typicalUA[i])+tua;
            tactual = Number(typicalActual[i])+tactual;

            /*
            console.log("&&&&&&");
            console.log("tda : "+ tda);
            console.log("tdm : "+ tdm);
            console.log("tuc : "+ tuc);
            console.log("tum : "+ tum);
            console.log("tua : "+ tua);
            console.log("tactual : "+ tactual);
            console.log("&&&&&&");*/
            
        }

        var tempSH:sectorHolder = {
            "Year": this.yearIndex,
            "SectorIDs": this.sectorIDArray,
            "SectorYields": sectorYield,
            "SectorDurations": sectorDuration,
            "SectorCurveShapes": sectorCurveShape,
            "SectorTypicalBank": sectorTypicalBank
        }
        this.sectorIDsHolder.push(tempSH);

        var tempCurve:sectorCurves = {
            "SectorCurveDA": sectorCurveDA,
            "SectorCurveDM": sectorCurveDM,
            "SectorCurveUC": sectorCurveUC,
            "SectorCurveUM": sectorCurveUM,
            "SectorCurveUA": sectorCurveUA,
            "SectorCurveActual": sectorCurveActual
        }
        this.sectorPoints.push(tempCurve);

        this.sectorObj = {
            "SectorPts": this.sectorPoints,
            "SectorInfo": this.sectorIDsHolder
        }
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.assetAllocationMc).populateAssets(sectors, sectorYield, sectorDuration, sectorTypicalBank, this.sectorNames);
        this.populateAssets(sectors, sectorYield, sectorDuration, sectorTypicalBank, this.sectorNames);
        ////////////////////////////////////////

        console.log("whichGame " + this.whichGame);
        console.log("year " + this.yearIndex);
        if (this.whichGame == 1 || this.whichGame == 4) {
            console.log("game 1 or 4")
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.gameMc.assetAllocationMc).updateLineSeries(1);
            this.updateLineSeries(1);
            ////////////////////////////////////////
        }else if (this.whichGame == 2) {
            console.log("game 1 or 4")
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.gameMc.assetAllocationMc).updateLineSeries(2);
            this.updateLineSeries(2);
            ////////////////////////////////////////
        }else if (this.whichGame == 3) {
            if (this.yearIndex == 0) {
                console.log("game 3 year 1")
                ////////////////////////////////////////
                //MovieClip(gameHolderMc.gameMc.assetAllocationMc).updateLineSeries(31);
                this.updateLineSeries(31);
                ////////////////////////////////////////
            }else if (this.yearIndex == 1) {
                console.log("game 3 year 2")
                ////////////////////////////////////////
                //MovieClip(gameHolderMc.gameMc.assetAllocationMc).updateLineSeries(32);
                this.updateLineSeries(32);
                ////////////////////////////////////////
            }else if (this.yearIndex == 2) {
                console.log("game 3 year 3")
                ////////////////////////////////////////
                //MovieClip(gameHolderMc.gameMc.assetAllocationMc).updateLineSeries(33);
                this.updateLineSeries(33);
                ////////////////////////////////////////
            }
        }
        
        this.typicalBondPortfolio = tactual;

        console.log("**********");
        console.log("tactual");
        console.log(tactual);
        console.log("**********");
    }

    public setGameValue(currArrayID, potentialRemaining) {
        console.log("setGameValue : " + currArrayID + " : " + potentialRemaining);
        this.sectorSelectedIndex = currArrayID;
        this.gameData[currArrayID].GameValue = potentialRemaining;
        console.log(this.gameData[currArrayID]);
    }

    public updateTotalAssets() {
        console.log("updateTotalAssets");
        //sliderUpdated = true;
        this.sliderArray = [];
        
        this.sectorTotal = 0;
        for (var i:number=0; i< this.gameData.length; i++)
        {
            if (this.gameData[i].GameValue > 25)  {
                this.gameData[i].GameValue = 25;
            }
            else if (this.gameData[i].GameValue < 0) {
                this.gameData[i].GameValue = 0;
            }

            this.sliderArray.push(Number(this.gameData[i].GameValue));
            this.sectorTotal += this.gameData[i].GameValue;
            //console.log(this.gameData[i].GameValue);
        }

        if(this.sectorTotal > 100) {
            this.sectorTotal = 100;
        }

        this._srvc.YearGameCompleted(this.sectorTotal ==100);

        //console.log("sectorTotal : " + this.sectorTotal);
        //console.log(this.gameData);

        /*
        //////////////// hack to recalc
        if(this.sectorTotal > 100) { //allocated too much
            //var iChanged = 0;
            for (var i:number=0; i< this.gameData.length; i++) //identify what changed
            {
                if (this.gameData[i].GameValue != this.gameDataOld[i]) {
                    this.gameData[i].GameValue = (100 - this.sectorTotalOld) + this.gameDataOld[i];
                    //iChanged = i;
                    break;
                }
            }
            this.sectorTotal = 100;
        }
        
        this.gameDataOld = [];
        for (var i:number=0; i< this.gameData.length; i++) //identify what changed
        {
            this.gameDataOld.push(this.gameData[i].GameValue);
        }
        
        this.sectorTotalOld = this.sectorTotal;
        //////////////// end hack to recalc
        */

        //totalAssetsMc.gotoAndStop(totalAssets);
        //totalAssetsMc.percentTxt.text = totalAssets + "%";
        
        //trace(whichTRA);
        if(this.whichTRA == 2){
            //actualBars.dataProvider = ShapeCalculation(typicalBank , whichID, 2);
            this.chart_data_myBank = this.ShapeCalculation(this.typicalBank , this.sectorSelectedIndex, 2);
        }else if (this.whichTRA == 4){
            //actualBars.dataProvider = parent.parent.parent.advanceShapeArray;
            this.chart_data_myBank = this.advanceShapeArray;
        }else {
            var tempArray = this.ShapeCalculation(this.typicalBank , this.sectorSelectedIndex, 2);
        }
        //yourBars.dataProvider = ShapeCalculation(sliderArray ,whichID, 1);
        this.chart_data_myBank = this.ShapeCalculation(this.sliderArray, this.sectorSelectedIndex, 1);   // Graph for TRE
    
        this.calcTRE();
    }

//gets graph for yield//----------------------------------------------------------------------------------------------------------------------------------------------
    private setUpYieldCurve()
    {
        this.curveNumbers = [];
        this.curveNames = [];
        this.oldCurve = [];
        ////////////////////////////////////////var curveShape:Array = new Array;
        for(var i:number = 0; i<8; i++){
            this.curveNumbers.push(Number(this.Setup.Year[this.yearIndex].YieldCurve.Point[i].Text));
            this.curveNames.push(this.Setup.Year[this.yearIndex].YieldCurve.Point[i].Name);
        }
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.staticNumMc).setUpChart(curveNumbers, curveNames);
        ////////////////////////////////////////
    }
//setup top bar//-----------------------------------------------------------------------------------------------------------------------------------------------------
    private setUpTimer()
    {
        var count: number = Number(this.Setup.Year[this.yearIndex].MinutesToComplete);
        this.years = Number(this.Setup.NumberOfYearsToPlay);
        this.timeLimit = count;
        
        var timer:timerSettings = {
            Length: (count * 60),
            From: (this.yearIndex/this.years)*100,
            To: ((this.yearIndex+1)/this.years)*100,
            Year: "Year " + (this.yearIndex+1) //this.years //
        };
        //this.years++;

        ////////////////////////////////////////
        //MovieClip(gameHolderMc.headerMc).loadTimeLimit(count, years - 1);
        this._srvc.SetTimer(timer);
        ////////////////////////////////////////
    }
    private setUpAssets()
    {
        //setup static assets//-------------------------------------------------------------------------------------------------------------------------------------
        var bonds: number = this.Setup.Year[this.yearIndex].BankBalanceSheet.Bonds;
        var loans: number = this.Setup.Year[this.yearIndex].BankBalanceSheet.Loans;
        var advances: number = this.Setup.Year[this.yearIndex].BankBalanceSheet.Advances;
        var deposits: number = this.Setup.Year[this.yearIndex].BankBalanceSheet.Deposits;
        var equity: number = this.Setup.Year[this.yearIndex].BankBalanceSheet.Equity;
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.staticNumMc).loadFields(bonds, loans, advances, deposits, equity);
        this.loadFields(bonds, loans, advances, deposits, equity);
        ////////////////////////////////////////
    }
    private setUpAdvancesShape()
    {
        this.advanceShapeArray = [];

        for(var i:number = 0; i<5; i++){
            this.advanceShapeArray.push(Number(this.Setup.Year[this.yearIndex+1].ShapeOfAdvances.Point[i].Text));
        }
    }
    private getNumberOfGames()
    {
        /*var directory:File = File.applicationDirectory; 
        directory = directory.resolvePath("xml"); 
        var list:Array = directory.getDirectoryListing();
        var i:uint;
        for (i = 0; i < list.length; i++) {
        }
        MovieClip(gameHolderMc.headerMc).setGameSelection(i);*/

        ////////////////////////////////////////
        //MovieClip(gameHolderMc.headerMc).setGameSelection(4);
        ////////////////////////////////////////
        //need to set something to 4
    }
//load balance sheet//----------------------------------------------------------------------------------------------------------------------------------------------------
    private createBalanceSheet(sheet: gameBalanceSheet[])  {
        //for(var i=0; i<this.Setup.NumberOfYearsToPlay; i++){
        for(var i=0; i<=this.Setup.NumberOfYearsToPlay; i++){     
            var itemArray:gameBalanceSheet = new gameBalanceSheet(i+1);
            sheet.push(itemArray);
        }
    }
    private loadBalanceSheet(year:number) {
        console.log("loadBalanceSheet");

        var setupYear: year = this.Setup.Year[year];
        //console.log("setupYear");
        //console.log(setupYear);
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet[year];
        //console.log("bankBalanceYear");
        //console.log(bankBalanceYear);

        var typicalBalanceYear: gameBalanceSheet = this.TypicalBankBalanceSheet[year];
        //console.log("typicalBalanceYear");
        //console.log(typicalBalanceYear);


        bankBalanceYear.Bonds.Balance = Number(setupYear.BankBalanceSheet.Bonds);
        bankBalanceYear.Loans.Balance = Number(setupYear.BankBalanceSheet.Loans);
        bankBalanceYear.Advances.Balance = Number(setupYear.BankBalanceSheet.Advances);
        bankBalanceYear.Deposits.Balance = Number(setupYear.BankBalanceSheet.Deposits);
        bankBalanceYear.Equity.Balance = Number(setupYear.BankBalanceSheet.Equity);
        
        this.currentGame_Assets_Bonds = Number(setupYear.BankBalanceSheet.Bonds);
        this.currentGame_Assets_Loans = Number(setupYear.BankBalanceSheet.Loans);
        this.currentGame_Assets_Total = Number(this.currentGame_Assets_Bonds) + Number(this.currentGame_Assets_Loans);
        this.currentGame_Liabilities_Advances = Number(setupYear.BankBalanceSheet.Advances);
        this.currentGame_Liabilities_Deposits = Number(setupYear.BankBalanceSheet.Deposits);
        this.currentGame_Liabilities_Total = Number(this.currentGame_Liabilities_Advances) + Number(this.currentGame_Liabilities_Deposits);
        this.currentGame_Equity_Liabilities = Number(setupYear.BankBalanceSheet.Equity);



        typicalBalanceYear.Bonds.Balance = Number(setupYear.TypicalBankBalanceSheet.Bonds);
        typicalBalanceYear.Loans.Balance = Number(setupYear.TypicalBankBalanceSheet.Loans);
        typicalBalanceYear.Advances.Balance = Number(setupYear.TypicalBankBalanceSheet.Advances);
        typicalBalanceYear.Deposits.Balance = Number(setupYear.TypicalBankBalanceSheet.Deposits);
        typicalBalanceYear.Equity.Balance = Number(setupYear.TypicalBankBalanceSheet.Equity);

        this.loadBalanceSheetShape(bankBalanceYear.Loans, setupYear, setupYear.ShapeOfLoans);
        this.loadBalanceSheetShape(bankBalanceYear.Advances, setupYear, setupYear.ShapeOfAdvances);
        this.loadBalanceSheetShape(bankBalanceYear.Deposits, setupYear, setupYear.ShapeOfDeposits);

        this.loadBalanceSheetShape(typicalBalanceYear.Loans, setupYear, setupYear.ShapeOfLoans);
        this.loadBalanceSheetShape(typicalBalanceYear.Advances, setupYear, setupYear.ShapeOfAdvances);
        this.loadBalanceSheetShape(typicalBalanceYear.Deposits, setupYear, setupYear.ShapeOfDeposits);
    }
    
    private loadBalanceSheetShape(sheet:balanceSheetDetail, year:year, shapeNode:shape):void
    {
        console.log("loadBalanceSheetShape : " + year.Index);

        sheet.DA = Number(shapeNode.Point.find((item => item.Name == "DA")).Text);
        sheet.DM = Number(shapeNode.Point.find((item => item.Name == "DM")).Text);
        sheet.UC = Number(shapeNode.Point.find((item => item.Name == "UC")).Text);
        sheet.UM = Number(shapeNode.Point.find((item => item.Name == "UM")).Text);
        sheet.UA = Number(shapeNode.Point.find((item => item.Name == "UA")).Text);
        sheet.Actual = shapeNode.ActualBTR;

        
        console.log("**********");
        console.log("sheet.DA : " + sheet.DA);
        console.log("sheet.DM : " + sheet.DM);
        console.log("sheet.UC : " + sheet.UC);
        console.log("sheet.UM : " + sheet.UM);
        console.log("sheet.UA : " + sheet.UA);
        console.log("sheet.Actual : " + sheet.Actual);
        console.log("**********");
        
    }

//balanace//-----------------------------------------------------------------------------------------------------------------------------------------------------
    public updateBalanceSheet(year:number)
    {
        console.log("updateBalanceSheet");
        
        var newEquity:number;
        var typicalNewEquity:number;
        var newAssets:number;
        var newLiablilities:number;
        var nextYear = year+1;

        if(nextYear == 3){
            nextYear = 2;
        }
        
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet[year]; //.find(item => item.Index == year);
        var bankBalanceNext: gameBalanceSheet = this.BankBalanceSheet[year + 1]; //.find(item => item.Index == (year + 1));

        var typicalBalanceYear: gameBalanceSheet = this.TypicalBankBalanceSheet[year]; //.find(item => item.Index == year);
        var typicalBalanceNext: gameBalanceSheet = this.TypicalBankBalanceSheet[year + 1]; //.find(item => item.Index == (year + 1));

        //maintain cap ratio of 10%
        
        //calc new equity
        
        //current equity multiplied by TRE
        newEquity = Math.round(bankBalanceYear.Equity.Balance * (1 + bankBalanceYear.Equity.Actual));
        this.yearEquity = newEquity;

        console.log("newEquity : " + newEquity);
        
        //calculate growth / loss of assets if maintaining 10% cap ratio
        newAssets = newEquity/0.1;
        console.log("newAssets : " + newAssets);

        bankBalanceNext.Bonds.Balance = Math.round(newAssets * this._globals.BOND_PERCENT); 
        //calculate size of bond portfolio based on set percentage of assets
        bankBalanceNext.Loans.Balance =  newAssets - bankBalanceNext.Bonds.Balance;
        newLiablilities = newAssets - newEquity;
        bankBalanceNext.Advances.Balance  = bankBalanceNext.Bonds.Balance;
        //Bond and Advance portfolio must remain same size
        bankBalanceNext.Deposits.Balance = newLiablilities - bankBalanceNext.Advances.Balance;
        bankBalanceNext.Equity.Balance = newEquity;	
        //current equity multiplied by TRE
        typicalNewEquity = Math.round(typicalBalanceYear.Equity.Balance * (1+typicalBalanceYear.Equity.Actual));
        
        //console.log("typicalBalanceYear.Equity.Balance: " + typicalBalanceYear.Equity.Balance);
        //console.log("typicalBalanceYear.Equity.Actual: " + typicalBalanceYear.Equity.Actual);
        //console.log("typicalNewEquity: " + typicalNewEquity);

        console.log("1 : " + bankBalanceNext.Bonds.Balance);

        console.log("1 : " + bankBalanceNext.Bonds.DA);
        console.log("1 : " + bankBalanceNext.Bonds.DM);
        console.log("1 : " + bankBalanceNext.Bonds.Actual);
        console.log("1 : " + bankBalanceNext.Bonds.UA);
        console.log("1 : " + bankBalanceNext.Bonds.UC);
        console.log("1 : " + bankBalanceNext.Bonds.UM);



        console.log("2 : " + bankBalanceNext.Loans.Balance);
        console.log("2 : " + bankBalanceNext.Loans.DM);
        console.log("2 : " + bankBalanceNext.Loans.Actual);
        console.log("2 : " + bankBalanceNext.Loans.UA);
        console.log("2 : " + bankBalanceNext.Loans.UC);
        console.log("2 : " + bankBalanceNext.Loans.UM);

        console.log("3 : " + newLiablilities);

        console.log("4 : " + bankBalanceNext.Advances.Balance);
        console.log("4 : " + bankBalanceNext.Advances.DM);
        console.log("4 : " + bankBalanceNext.Advances.Actual);
        console.log("4 : " + bankBalanceNext.Advances.UA);
        console.log("4 : " + bankBalanceNext.Advances.UC);
        console.log("4 : " + bankBalanceNext.Advances.UM);

        console.log("5 : " + bankBalanceNext.Deposits.Balance);
        console.log("5 : " + bankBalanceNext.Deposits.DM);
        console.log("5 : " + bankBalanceNext.Deposits.Actual);
        console.log("5 : " + bankBalanceNext.Deposits.UA);
        console.log("5 : " + bankBalanceNext.Deposits.UC);
        console.log("5 : " + bankBalanceNext.Deposits.UM);

        console.log("6 : " + bankBalanceNext.Equity.Balance);
        console.log("6 : " + bankBalanceNext.Equity.DM);
        console.log("6 : " + bankBalanceNext.Equity.Actual);
        console.log("6 : " + bankBalanceNext.Equity.UA);
        console.log("6 : " + bankBalanceNext.Equity.UC);
        console.log("6 : " + bankBalanceNext.Equity.UM);

        console.log("bankBalanceNext : " + bankBalanceNext);
        console.log(bankBalanceNext);
        console.log("typicalBalanceNext : " + typicalBalanceNext);
        console.log(typicalBalanceNext);

        this.typicalEquity = typicalNewEquity;
        
        //calculate growth / loss of assets if maintaining 10% cap ratio
        newAssets = typicalNewEquity/0.1;
        typicalBalanceNext.Bonds.Balance = Math.round(newAssets * this._globals.BOND_PERCENT); 
        //calculate size of bond portfolio based on set percentageof assets
        typicalBalanceNext.Loans.Balance = newAssets - typicalBalanceNext.Bonds.Balance;
        newLiablilities = newAssets - typicalNewEquity;
        typicalBalanceNext.Advances.Balance = typicalBalanceNext.Bonds.Balance;
        //Bond and Advance portfolio must remain same size
        typicalBalanceNext.Deposits.Balance = newLiablilities - typicalBalanceNext.Advances.Balance;
        typicalBalanceNext.Equity.Balance = typicalNewEquity;
        
        console.log("1 : " + typicalBalanceNext.Bonds.Balance);

        console.log("1 : " + typicalBalanceNext.Bonds.DA);
        console.log("1 : " + typicalBalanceNext.Bonds.DM);
        console.log("1 : " + typicalBalanceNext.Bonds.Actual);
        console.log("1 : " + typicalBalanceNext.Bonds.UA);
        console.log("1 : " + typicalBalanceNext.Bonds.UC);
        console.log("1 : " + typicalBalanceNext.Bonds.UM);



        console.log("2 : " + typicalBalanceNext.Loans.Balance);
        console.log("2 : " + typicalBalanceNext.Loans.DM);
        console.log("2 : " + typicalBalanceNext.Loans.Actual);
        console.log("2 : " + typicalBalanceNext.Loans.UA);
        console.log("2 : " + typicalBalanceNext.Loans.UC);
        console.log("2 : " + typicalBalanceNext.Loans.UM);

        console.log("3 : " + newLiablilities);

        console.log("4 : " + typicalBalanceNext.Advances.Balance);
        console.log("4 : " + typicalBalanceNext.Advances.DM);
        console.log("4 : " + typicalBalanceNext.Advances.Actual);
        console.log("4 : " + typicalBalanceNext.Advances.UA);
        console.log("4 : " + typicalBalanceNext.Advances.UC);
        console.log("4 : " + typicalBalanceNext.Advances.UM);

        console.log("5 : " + typicalBalanceNext.Deposits.Balance);
        console.log("5 : " + typicalBalanceNext.Deposits.DM);
        console.log("5 : " + typicalBalanceNext.Deposits.Actual);
        console.log("5 : " + typicalBalanceNext.Deposits.UA);
        console.log("5 : " + typicalBalanceNext.Deposits.UC);
        console.log("5 : " + typicalBalanceNext.Deposits.UM);

        console.log("6 : " + typicalBalanceNext.Equity.Balance);
        console.log("6 : " + typicalBalanceNext.Equity.DM);
        console.log("6 : " + typicalBalanceNext.Equity.Actual);
        console.log("6 : " + typicalBalanceNext.Equity.UA);
        console.log("6 : " + typicalBalanceNext.Equity.UC);
        console.log("6 : " + typicalBalanceNext.Equity.UM);





        //set this years rock
        if(year < this.years){
            console.log(year); 
			console.log(this.years); // In Flash, this is showing up as 4????? Here it is 3...


            var setupYear: year = this.Setup.Year.find(item => item.Index == (year+2));
            console.log("setupYear : " + setupYear.Index);
            this.loadBalanceSheetShape(bankBalanceNext.Loans, setupYear, setupYear.ShapeOfLoans);
            this.loadBalanceSheetShape(bankBalanceNext.Advances, setupYear, setupYear.ShapeOfAdvances);
            this.loadBalanceSheetShape(bankBalanceNext.Deposits, setupYear, setupYear.ShapeOfDeposits);

            this.loadBalanceSheetShape(typicalBalanceNext.Loans, setupYear, setupYear.ShapeOfLoans);
            this.loadBalanceSheetShape(typicalBalanceNext.Advances, setupYear, setupYear.ShapeOfAdvances);
            this.loadBalanceSheetShape(typicalBalanceNext.Deposits, setupYear, setupYear.ShapeOfDeposits);
        }
        
        var newShapeArray:number[] = [bankBalanceNext.Bonds.Balance, bankBalanceNext.Loans.Balance, bankBalanceNext.Advances.Balance, bankBalanceNext.Deposits.Balance, bankBalanceNext.Equity.Balance];
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.staticNumMc).loadFields(BankBalanceSheet[year+1][_globals.BalanceSheetItems_Bonds][_globals.BalanceSheetItemsDetails_Balance], 
        //BankBalanceSheet[year+1][_globals.BalanceSheetItems_Loans][_globals.BalanceSheetItemsDetails_Balance], 
        //BankBalanceSheet[year+1][_globals.BalanceSheetItems_Advances][_globals.BalanceSheetItemsDetails_Balance], 
        //BankBalanceSheet[year+1][_globals.BalanceSheetItems_Deposits][_globals.BalanceSheetItemsDetails_Balance], 
        //BankBalanceSheet[year+1][_globals.BalanceSheetItems_Equity][_globals.BalanceSheetItemsDetails_Balance]);
        this.loadFields(bankBalanceNext.Bonds.Balance, bankBalanceNext.Loans.Balance, bankBalanceNext.Advances.Balance, bankBalanceNext.Deposits.Balance, bankBalanceNext.Equity.Balance);
        ////////////////////////////////////////
        
    }
    public calcTRE()
    {
        console.log("futureShape : calcTRE : yearIndex : " + this.yearIndex)
        var assets:number;
        var liability:number;
        var equity:number;
        var netEndDollars:number;
        
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet[this.yearIndex]; 
        var typicalBalanceYear: gameBalanceSheet = this.TypicalBankBalanceSheet[this.yearIndex];

        console.log(bankBalanceYear.Advances)
        console.log(bankBalanceYear.Bonds)
        console.log(bankBalanceYear.Deposits)
        console.log(bankBalanceYear.Equity)
        console.log(bankBalanceYear.Loans)

        console.log(typicalBalanceYear.Advances)
        console.log(typicalBalanceYear.Bonds)
        console.log(typicalBalanceYear.Deposits)
        console.log(typicalBalanceYear.Equity)
        console.log(typicalBalanceYear.Loans)

        //for(i=_globals.BalanceSheetItemsDetails_DA; i<= _globals.BalanceSheetItemsDetails_Actual;i++){
        for(var i=1; i<= 6;i++){
            assets = (bankBalanceYear.Bonds.Balance * Math.pow((1 + bankBalanceYear.Bonds.getCol(i)/200), 2))+
            (bankBalanceYear.Loans.Balance * Math.pow((1 + bankBalanceYear.Loans.getCol(i)/200), 2));

            liability = (bankBalanceYear.Advances.Balance * Math.pow((1 + bankBalanceYear.Advances.getCol(i)/200), 2))+
            (bankBalanceYear.Deposits.Balance * Math.pow((1+bankBalanceYear.Deposits.getCol(i)/200), 2));
            
            equity = bankBalanceYear.Equity.Balance;
            
            
            netEndDollars = (assets-liability-this._globals.FEE_EXPENSE)/equity;
            
            //console.log("bankBalanceYear.Bonds.Balance " + i + ": " + bankBalanceYear.Bonds.Balance);
            //console.log("bankBalanceYear.Bonds.getCol(i) " + i + ": " + bankBalanceYear.Bonds.getCol(i));
            //console.log("bankBalanceYear.Loans.Balance " + i + ": " + bankBalanceYear.Loans.Balance);
            //console.log("bankBalanceYear.Loans.getCol(i) " + i + ": " + bankBalanceYear.Loans.getCol(i));

            console.log("bank assets " + i + ": " + assets);
            console.log("bank liability " + i + ": " + liability);
            //console.log("bank equity " + i + ": " + equity);
            console.log("bank netEndDollars " + i + ": " + netEndDollars);
            console.log("----------");
            if(netEndDollars < 0){
                netEndDollars = 0;
            }
            
            bankBalanceYear.Equity.setCol(i, ((Math.pow(netEndDollars,(1/2)))-1)*2);
        }
        
        //cap ratio
        //capRatio = new Number();
        this.capRatio = equity/bankBalanceYear.Bonds.Balance + bankBalanceYear.Loans.Balance;

        
        console.log("bankBalanceYear");
        console.log(bankBalanceYear.Bonds);
        console.log("typicalBalanceYear");
        console.log(typicalBalanceYear.Bonds);

        //TypicalBankBalanceSheet
        //for(i=_globals.BalanceSheetItemsDetails_DA; i<= _globals.BalanceSheetItemsDetails_Actual;i++){
        for(var i=1; i<= 6;i++){
            assets = (typicalBalanceYear.Bonds.Balance * Math.pow((1 + typicalBalanceYear.Bonds.getCol(i)/200), 2))+
                     (typicalBalanceYear.Loans.Balance * Math.pow((1 + typicalBalanceYear.Loans.getCol(i)/200), 2));

            console.log("typicalBalanceYear.Bonds.Balance : " + typicalBalanceYear.Bonds.Balance);
            console.log("typicalBalanceYear.Bonds.getCol(i) : " + typicalBalanceYear.Bonds.getCol(i));

            liability = (typicalBalanceYear.Advances.Balance * Math.pow((1 + typicalBalanceYear.Advances.getCol(i)/200), 2))+
                        (typicalBalanceYear.Deposits.Balance * Math.pow((1 + typicalBalanceYear.Deposits.getCol(i)/200), 2));
            
            equity = typicalBalanceYear.Equity.Balance;
            
            
            netEndDollars = (assets-liability-this._globals.FEE_EXPENSE)/equity;
            
            
            //console.log("typicalBalanceYear.Bonds.Balance " + i + ": " + typicalBalanceYear.Bonds.Balance);
            //console.log("typicalBalanceYear.Bonds.getCol(i) " + i + ": " + typicalBalanceYear.Bonds.getCol(i));
            //console.log("typicalBalanceYear.Loans.Balance " + i + ": " + typicalBalanceYear.Loans.Balance);
            //console.log("typicalBalanceYear.Loans.getCol(i) " + i + ": " + typicalBalanceYear.Loans.getCol(i));


            console.log("typical assets " + i + ": " + assets);
            console.log("typical liability " + i + ": " + liability);
            //console.log("typical equity " + i + ": " + equity);
            console.log("typical netEndDollars " + i + ": " + netEndDollars);
            //console.log("typical col " + i + ": " + ((Math.pow(netEndDollars,(1/2)))-1)*2);
            console.log("----------");


            if(netEndDollars < 0){
                netEndDollars = 0;
            }
            
            typicalBalanceYear.Equity.setCol(i, ((Math.pow(netEndDollars,(1/2)))-1)*2);

        }

        this.myTRE = bankBalanceYear.Equity.Actual * 100;
        
        this.typicalTRE = typicalBalanceYear.Equity.Actual * 100;
        
        this.myBankShape = new Array(bankBalanceYear.Equity.DA, bankBalanceYear.Equity.DM, bankBalanceYear.Equity.UC, bankBalanceYear.Equity.UM,bankBalanceYear.Equity.UA, bankBalanceYear.Equity.Actual);	
        this.typicalBankShape = new Array(typicalBalanceYear.Equity.DA, typicalBalanceYear.Equity.DM,typicalBalanceYear.Equity.UC,typicalBalanceYear.Equity.UM, typicalBalanceYear.Equity.UA, typicalBalanceYear.Equity.Actual);
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.helpMc.updateDataProvider(myBankShape, typicalBankShape));
        this.updateDataProvider(this.myBankShape, this.typicalBankShape);
        ////////////////////////////////////////
        
        this.bondPortfolio = bankBalanceYear.Bonds.Actual;
        
        this.typicalBondPortfolio = typicalBalanceYear.Bonds.Actual;
    }

    public setUpLeverage()
    {
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet.find(item => item.Index == this.yearIndex);

        var newLowBonds = bankBalanceYear.Bonds.Balance;
        this.newCapRatio = bankBalanceYear.Equity.Balance / (newLowBonds + bankBalanceYear.Loans.Balance);
        var tmpCapRatio = this.newCapRatio;
        this.OriginalBonds = bankBalanceYear.Bonds.Balance;
        
        var i:number = 0;
        
        //console.log("newLowBonds : " + newLowBonds)
        //console.log("newCapRatio : " + newCapRatio)
        //console.log("-------")
        while(tmpCapRatio > this._globals.lowCR) 
        {
            i = i + 1;
            newLowBonds = newLowBonds + 5000000;
            tmpCapRatio = bankBalanceYear.Equity.Balance / (newLowBonds + bankBalanceYear.Loans.Balance);
            //console.log("newLowBonds : " + newLowBonds)
            //console.log("newCapRatio : " + tmpCapRatio)
            //console.log("i : "+i)
        }
        //console.log("--------")
        
        newLowBonds = newLowBonds - 5000000;
        //console.log("newLowBonds: " + newLowBonds + "newCapRatio: " + newCapRatio);
        
        var newHighBonds = bankBalanceYear.Bonds.Balance;
        tmpCapRatio = bankBalanceYear.Equity.Balance / (newLowBonds + bankBalanceYear.Loans.Balance);

        while(tmpCapRatio < this._globals.highCR) 
        {
            newHighBonds = newHighBonds - 5000000;
            tmpCapRatio = bankBalanceYear.Equity.Balance / (newHighBonds + bankBalanceYear.Loans.Balance);
        }
        newHighBonds = newHighBonds + 5000000;
        console.log("newLowBonds: " + newHighBonds + "newCapRatio: " + tmpCapRatio);
        
        this.highBonds = newHighBonds;
        this.lowBonds = newLowBonds;
        this.calcLeveragePct();        
    }
    public updateLeverage(stepNum: number):void
    {
        //trace("updateLeverage: " + stepNum + " - " + lowBonds);
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet.find(item => item.Index == this.yearIndex);

        bankBalanceYear.Bonds.Balance = Math.round((this.OriginalBonds-(5000000*stepNum)));
        bankBalanceYear.Advances.Balance = Math.round((this.OriginalBonds-(5000000*stepNum)));
        var bonds: number = bankBalanceYear.Bonds.Balance;
        var loans: number = bankBalanceYear.Loans.Balance;
        var advances: number = bankBalanceYear.Advances.Balance;
        var deposits: number = bankBalanceYear.Deposits.Balance;
        var equity: number = bankBalanceYear.Equity.Balance;
        
        ////////////////////////////////////////
        //MovieClip(gameHolderMc.gameMc.staticNumMc).loadFields(bonds, loans, advances, deposits, equity);
        this.loadFields(bonds, loans, advances, deposits, equity);
        ////////////////////////////////////////

        var currentLeverage = bankBalanceYear.Bonds.Balance;
        this.newCapRatio = bankBalanceYear.Equity.Balance / (currentLeverage + bankBalanceYear.Loans.Balance);
        this.calcTRE();
        this.calcLeveragePct();        
    }
    
    public updateLeverageAddSub(addMonies:boolean)
    {
        //trace("updateLeverage: " + addMonies);
        var addSubDirection = -1; //subtract
        if (addMonies) addSubDirection = 1;
        
        var bankBalanceYear: gameBalanceSheet = this.BankBalanceSheet[this.yearIndex]; //this.BankBalanceSheet.find(item => item.Index == this.yearIndex);

        var currentLeverage = bankBalanceYear.Bonds.Balance + (addSubDirection * 5000000);
        this.newCapRatio = bankBalanceYear.Equity.Balance / (currentLeverage + bankBalanceYear.Loans.Balance);
        
        if(this.newCapRatio >= this._globals.lowCR && this.newCapRatio <= this._globals.highCR)
        {
            bankBalanceYear.Bonds.Balance = currentLeverage;
            bankBalanceYear.Advances.Balance = currentLeverage;
            var bonds: number = bankBalanceYear.Bonds.Balance;
            var loans: number = bankBalanceYear.Loans.Balance;
            var advances: number = bankBalanceYear.Advances.Balance;
            var deposits: number = bankBalanceYear.Deposits.Balance;
            var equity: number = bankBalanceYear.Equity.Balance;
            
            ////////////////////////////////////////
            //MovieClip(gameHolderMc.gameMc.staticNumMc).loadFields(bonds, loans, advances, deposits, equity);
            this.loadFields(bonds, loans, advances, deposits, equity);
            ////////////////////////////////////////

            this.calcTRE();
            //leverageMc.assetTxt.text = this.newCapRatio + "%";
        }else {
            currentLeverage = bankBalanceYear.Bonds.Balance;
            this.newCapRatio = bankBalanceYear.Equity.Balance / (currentLeverage + bankBalanceYear.Loans.Balance);
        }
        this.calcLeveragePct();
    }

    public calcLeveragePct() {        
        this.newCapPct = (this.newCapRatio - this._globals.lowCR) / (this._globals.highCR - this._globals.lowCR);
        this.newCapPct *= 100;
        this.newCapPct = Math.round(this.newCapPct);
    }

    public populateAssets(sectors:number, yieldArr:number[], duration:number[], typical:number[], name:string[]):void {
        console.log("futureShape : populateAssets")
        //this.assetsLoaded = true;
        ////reset assets
        //totalAssetsMc.gotoAndStop(1);
        //totalAssetsMc.percentTxt.text = "0%";
        //get year
        //gameYear = parent.parent.parent.year;
        //year = parent.parent.parent.year;		
        //get chart for typical
        this.typicalBank = typical;
        //determine what to show
        //whichTRA = parent.parent.parent.whichTRA;
        
        this.sectorSelectedName = "";
        this.sectorSelectedID = null;
        this.sectorSelectedIndex = -1;
        
        //put names on graph
        this.chart_categoryNames = [];
        for(var i:number=0; i<5; i++){
            this.chart_categoryNames.push(this.Setup.Year[0].Sector[0].Shape.Point[i].Name);
        }
        
        if(!this.whichTRA) this.whichTRA = 1;
        console.log("futureShape : populateAssets : this.whichTRA : " + this.whichTRA);
        if (this.whichTRA == 1) {
            //display	
            this.currentGame_Sector_Allocation_Title = "Asset Allocation";
            this.TRA_Title = "Bonds";
            this.chart_yAxisLabel = "Total Return on Assets";
            this.chart_legend_myBank = "";
            this.chart_legend_typical = "";
            this.chart_legend_bond = "(select from left)";
        } else if (this.whichTRA == 2) {
            //display
            this.currentGame_Sector_Allocation_Title = "Asset Allocation";
            this.chart_legend_myBank = "My Bank";
            this.chart_legend_typical = "Typical Bank";
            this.TRA_Title = "Total Return on Assets";
            this.chart_yAxisLabel = "Total Return on Assets";
            this.chart_legend_bond = "(select from left)"
            
            //chart
            this.updateTotalAssets();
            this.chart_data_typical = this.ShapeCalculation(typical, 1, 2);
        } else if (this.whichTRA == 3) {
            //display
            this.currentGame_Sector_Allocation_Title = "Proposed";
            this.chart_legend_myBank = "Proposed";
            this.chart_legend_typical = "Target Allocation";
            this.TRA_Title = "Total Return on Assets";
            this.chart_yAxisLabel = "Total Return on Assets";
            this.chart_legend_bond = "(select from left)";

            //chart
            this.updateTotalAssets();
            this.updateReturnsGraph(false);
            this.chart_data_typical = this.ShapeCalculation(this.sliderArray , this.sectorSelectedIndex, 1);

        } else if (this.whichTRA == 4) {
            //display
            this.currentGame_Sector_Allocation_Title = "Asset Allocation";
            this.chart_legend_myBank = "Proposed Allocation";
            this.chart_legend_typical = "Liabilities";
            this.chart_legend_myBank = "Proposed Allocation";
            this.chart_legend_typical = "Liabilities";
            this.TRA_Title = "TR of Assets vs. TC of Liabilities";
            this.chart_yAxisLabel = "TR of Assets vs. TC of Liabilities";
            this.chart_legend_bond = "(select from left)";

            // //chart
            this.updateTotalAssets();
            this.chart_data_typical = this.ShapeCalculation(typical , 1, 2);
            this.chart_data_myBank = this.ShapeCalculation(this.sliderArray , this.sectorSelectedIndex, 1);
            this.updateReturnsGraph(true);
        }

        console.log(this.whichTRA);
        if (this.whichTRE == 1) {
            this.updateReturnsBroker(this.sectorSelectedIndex);
        } else if (this.whichTRE == 2) {
            this.updateReturnsProCon(this.sectorSelectedIndex);
        } else if (this.whichTRE == 3) {
            //Added to reset the graph on next year of game 3
            this.updateReturnsBroker(this.sectorSelectedIndex);
            this.updateReturnsGraph(false);
            this.setAssetLine(this.sectorSelectedIndex);
        } else if (this.whichTRE == 4) {
            this.updateReturnsBroker(this.sectorSelectedIndex);
            this.updateReturnsGraph(true);
            this.setAssetLine(this.sectorSelectedIndex);
        };

        this.calcTRE();
        this.updateTotalAssets();
    }

    public infoClick(id:number, index: number) {
        //parent.parent.hideBloombergCTA();        
        //whichID = int(whatsClicked.parent.name.substr(8,9));
        
        this.sectorSelectedID = id;
        this.sectorSelectedIndex = index;

        if(this.whichTRA == 1){
            //bloomHolderMc.visible = true;
            //chart2.visible = false;
            //graphLines.visible = false;            
            //graphName.text = "";
        }
        
        if(this.whichTRE == 1){
            this.updateReturnsBroker(index);
        }else if(this.whichTRE == 2){
            this.updateReturnsProCon(index);
        }else if(this.whichTRE == 3){
            this.updateReturnsGraph(false);
        } else if (this.whichTRE == 4) {
            this.updateReturnsGraph(true);
        };

        this.setAssetLine(index);
    }

/*
    //make sliders dragable
    private function onSliderClick(event:MouseEvent):void {
        event.target.addEventListener(MouseEvent.MOUSE_UP, onSliderUp);
        stage.addEventListener(MouseEvent.MOUSE_UP, killStageListener);

        var totalAssetsRemaining = 100 - totalAssets;
        event.target.slideTo = totalAssetsRemaining * totalIncrement;
        
        if(totalAssetsRemaining > 25){
            event.target.slideTo = 127;
        }else{
            if(event.target.sliderAllocated > 0){
                event.target.slideTo = (totalAssetsRemaining + event.target.sliderAllocated) * totalIncrement;	
            }else{
                event.target.slideTo = (totalAssetsRemaining) * totalIncrement;
            }
        
        }
        
        if(event.target.slideTo > 127) event.target.slideTo = 127;
        
        event.target.parent.slideGuide.width = event.target.slideTo + 13;
        
        rectangle = new Rectangle(0, 0, event.target.slideTo, 0);
        event.target.startDrag(false, rectangle);
        event.target.parent.addEventListener(Event.ENTER_FRAME, updateSlider);
    }
    
    //minus button functionality
    private function onMinusClick(event:MouseEvent):void {
        whatsClicked = MovieClip(event.target);
        var tempTotal:Number = new Number();
        tempTotal = whatsClicked.parent.bondAssets;
        if (totalAssets >= 0) {
            if (whatsClicked.parent.sliderMc.x >= 2.5) {
                if (event.target.slideTo > 127) event.target.slideTo = 127;
                var newPosition = whatsClicked.parent.sliderMc.x;
                whatsClicked.parent.bondAssets = whatsClicked.parent.bondAssets - 1;
                
                whatsClicked.parent.slideGuide2.width = whatsClicked.parent.sliderMc.x + 6;
                whatsClicked.parent.sliderMc.sliderAllocated = whatsClicked.parent.bondAssets;
                whatsClicked.parent.sliderMc.x = whatsClicked.parent.sliderMc.x - totalIncrement;
                                    
                whatsClicked.parent.slideGuide.width = event.target.slideTo + 13;
                totalAssets -= Math.abs(tempTotal - whatsClicked.parent.bondAssets);
            }else {
                whatsClicked.parent.assetTxt.text = 0;
            }
        }
        
        this.updateTotalAssets();
        whatsClicked.parent.assetTxt.text = whatsClicked.parent.bondAssets;
    }
    //add button functionality
    private function onAddClick(event:MouseEvent):void {
        whatsClicked = MovieClip(event.target);
        var tempTotal:Number = new Number();
        tempTotal = whatsClicked.parent.bondAssets;
        if (totalAssets < 100) {
            rectangle = new Rectangle(0, 0, whatsClicked.parent.sliderMc.slideTo, 0);

            if (whatsClicked.parent.sliderMc.x <= rectangle.width-4) {
                
                var newPosition = whatsClicked.parent.sliderMc.x;
                whatsClicked.parent.bondAssets = whatsClicked.parent.bondAssets + 1;
                whatsClicked.parent.slideGuide2.width = whatsClicked.parent.sliderMc.x + 6;
                whatsClicked.parent.sliderMc.sliderAllocated = whatsClicked.parent.bondAssets;

                whatsClicked.parent.sliderMc.x = whatsClicked.parent.sliderMc.x + totalIncrement;
                                    
                whatsClicked.parent.slideGuide.width = event.target.slideTo + 13;
                totalAssets += Math.abs(tempTotal - whatsClicked.parent.bondAssets);	
            }
        }
        this.updateTotalAssets();
        whatsClicked.parent.assetTxt.text = whatsClicked.parent.bondAssets;
    }
    private function onSliderUp(event:MouseEvent):void {
        whatsClicked = MovieClip(event.target);
        whatsClicked.removeEventListener(MouseEvent.MOUSE_UP, onSliderUp);

        for (i=0; i<slidersFields.length; i++) {
            slidersFields[i].parent.stopDrag();
            slidersFields[i].parent.removeEventListener(Event.ENTER_FRAME, updateSlider);
        }
        whatsClicked.x = whatsClicked.parent.bondAssets * 5.08;
        
    }
    
    private function killStageListener(event:MouseEvent):void
    {
        stage.removeEventListener(MouseEvent.MOUSE_UP, killStageListener);
        for (i=0; i<slidersFields.length; i++) {
            slidersFields[i].parent.stopDrag();
            slidersFields[i].parent.removeEventListener(Event.ENTER_FRAME, updateSlider);
        }
    }
    
    private function updateTextFields():void
    {
        whatsClicked.assetTxt.text = whatsClicked.bondAssets;
        var tempTotal:Number = new Number();
        tempTotal = whatsClicked.bondAssets;
    }
    //update the slider text
    private function updateSlider(event:Event):void {
        whatsClicked = MovieClip(event.target);
        whatsClicked.slideGuide2.width = whatsClicked.sliderMc.x + 6;
        
        var tempTotal:Number = new Number();
        tempTotal = whatsClicked.bondAssets;
        
        var newPosition = Math.ceil(event.target.mouseX - 6.5);

        if(whatsClicked.mouseX < 6.5) newPosition = 0;			
        if(whatsClicked.mouseX > whatsClicked.sliderMc.slideTo) newPosition = whatsClicked.sliderMc.slideTo;

        event.target.bondAssets = Math.ceil(newPosition/totalIncrement);
        whatsClicked.assetTxt.text = whatsClicked.bondAssets;
        
        whatsClicked.sliderMc.sliderAllocated = whatsClicked.bondAssets;
        
        if (tempTotal < whatsClicked.bondAssets) {
            totalAssets += Math.abs(tempTotal - whatsClicked.bondAssets);
        }else {
            totalAssets -= Math.abs(tempTotal - whatsClicked.bondAssets);
        }
        
        this.updateTotalAssets();
    }
    
    private function skinGraph():void
    {	
        chart2.setStyle("animationEnabled", true);
        chart2.setStyle("textFormat", new TextFormat("Frutiger 65 Bold", 11, 0xffffff, true));   
        chart2.setStyle("seriesColors", [0x00A3C8, 0xFF0000, 0x7FB23A]); 
        chart2.setStyle("seriesLineWeights", [2,2]);  
        chart2.setStyle("seriesMarkerSizes", [10,10]);  
        chart2.setStyle("backgroundSkin", CustomBackgroundSkin);  
        chart2.setStyle("horizontalAxisColor", 0x999999);  
        chart2.setStyle("verticalAxisColor", 0x999999);  
        chart2.setStyle("verticalAxisGridLineColor", 0x999999);  
        chart2.setStyle("verticalAxisTickColor", 0x999999);  
        chart2.setStyle("verticalAxisMinorTickColor", 0x999999);  
        chart2.setStyle("dataTipBackgroundSkin", CustomDataTipBackgroundSkin);
        chart2.setStyle("dataTipTextFormat", new TextFormat("Frutiger 65 Bold", 12, 0xffffff));
        chart2.setStyle("showVerticalAxisMinorGridLines", true);
        chart2.setStyle("showVerticalAxisMinorTicks", true);
        chart2.setStyle("horizontalAxisTickLength", 1);
        
        //chart2.setStyle("embedFonts", true);
        
        actualBars = new LineSeries();
        actualBars.displayName = "Typical Bank";
        
        idealLine = new LineSeries();
        idealLine.displayName = ""
        
        yourBars = new LineSeries();
        yourBars.displayName = "My Bank";
        
        this.chart2.dataProvider = [actualBars, idealLine, yourBars];
        
        yAxis.minimum = -10;
        yAxis.maximum = 30;

        chart2.verticalAxis = yAxis;
    }*/
    
    public updateLineSeries(year:Number) {
        //not needed and letting chart dynamically rescale
        console.log("updateLineSeries  :: year "+year);
        switch(year){
            case 1:
                this.chart_yAxisMin = -10;
                this.chart_yAxisMax = 30;
            break;
            
            case 2:
                this.chart_yAxisMin = -10;
                this.chart_yAxisMax = 20;
            break;
            
            case 31:
                this.chart_yAxisMin = -8;
                this.chart_yAxisMax = 19;
            break;
            
            case 32:
                this.chart_yAxisMin = -9;
                this.chart_yAxisMax = 19;
            break;
            
            case 33:
                this.chart_yAxisMin = -11;
                this.chart_yAxisMax = 24;
            break;
            
            case 4:
                this.chart_yAxisMin = -10;
                this.chart_yAxisMax = 30;
            break;            
        }        
    }
    
    public setOldCurve():void {
        if(this.sliderUpdated){
            //trace("ShapeCalculation(sliderArray ,whichID, 1) = " + ShapeCalculation(calcShape , whichID, 1))
            this.oldCurve = this.ShapeCalculation(this.calcShape , this.sectorSelectedIndex, 1);
        }else {
            this.sliderArray = new Array(0, 0, 0, 0, 0, 0);
            this.oldCurve = this.ShapeCalculation(this.sliderArray , this.sectorSelectedIndex, 1);
            this.chart_data_typical = this.ShapeCalculation(this.typicalBank ,this.sectorSelectedIndex, 2);
        }
    }
//--------------------------------------------------------------------------------------------------------------------------------------------------------		
    public ShapeCalculation(shape:number[], id:number, sheet:number):number[]
    {
        console.log("ShapeCalculation : Start");
        console.log("ShapeCalculation : " + this.yearIndex);

        var newShape:number[] = [];
        var newDA:number[] = [];
        var newDM:number[] = [];
        var newUC:number[] = [];
        var newUM:number[] = [];
        var newUA:number[] = [];
        var newActual:number[] = [];
        
        var da:number = 0;
        var dm:number = 0;
        var uc:number = 0;
        var um:number = 0;
        var ua:number = 0;
        var actual:number = 0;

        for(var i=0; i<shape.length; i++){
            newDA.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveDA[i]));
            newDM.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveDM[i]));
            newUC.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveUC[i]));
            newUM.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveUM[i]));
            newUA.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveUA[i]));
            newActual.push(Number((shape[i]/100))*Number(this.sectorObj.SectorPts[0].SectorCurveActual[i]));
        }
        for(i=0; i<shape.length; i++){
            da = newDA[i]+da;
            dm = newDM[i]+dm;
            uc = newUC[i]+uc;
            um = newUM[i]+um;
            ua = newUA[i]+ua;
            actual = newActual[i]+actual;
        }
        //if (sheet == 2)
            //trace("Sheet " + sheet + " - Actual: " + actual);
        
        this.calcShape = new Array(da, dm, uc, um, ua, actual);
        console.log(this.calcShape);
        this.newShape = this.calcShape;
        
        if(sheet == 2){
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.DA = da;
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.DM = dm;
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.UC = uc;
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.UM = um;
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.UA = ua;
            this.TypicalBankBalanceSheet[this.yearIndex].Bonds.Actual = actual;
        }
        this.BankBalanceSheet[this.yearIndex].Bonds.DA = da;
        this.BankBalanceSheet[this.yearIndex].Bonds.DM = dm;
        this.BankBalanceSheet[this.yearIndex].Bonds.UC = uc;
        this.BankBalanceSheet[this.yearIndex].Bonds.UM = um;
        this.BankBalanceSheet[this.yearIndex].Bonds.UA = ua;
        this.BankBalanceSheet[this.yearIndex].Bonds.Actual = actual;
        
        da *= 100;
        da = Math.ceil(da);
        da /= 100;
        
        dm *= 100;
        dm = Math.ceil(dm);
        dm /= 100;
        
        uc *= 100;
        uc = Math.ceil(uc);
        uc /= 100;
        
        um *= 100;
        um = Math.ceil(um);
        um /= 100;
        
        ua *= 100;
        ua = Math.ceil(ua);
        ua /= 100;
                
        
        newShape.push(da, dm, uc, um, ua);

        console.log("ShapeCalculation : End");

        return newShape;
    }
    public updateDataProvider(myBankShape:number[], typicalBankShape:number[]):void
    {	
        var newShapeArray:number[] = [];
        var newTypicalShapeArray:number[] = [];
        var newPoint:number;
        var newTypicalPoint:number;
        
        for(var i:number=0; i<5; i++){
            newPoint = myBankShape[i];
            newPoint *= 10000;
            newPoint = Math.round(newPoint);
            newPoint /= 100;
            newShapeArray.push(newPoint);
            
            newTypicalPoint = typicalBankShape[i];
            newTypicalPoint *= 10000;
            newTypicalPoint = Math.round(newTypicalPoint);
            newTypicalPoint /= 100;
            newTypicalShapeArray.push(newTypicalPoint);
        }
        this.TRE_data_myBank = (newShapeArray);
        this.TRE_data_typical = (newTypicalShapeArray);
    }

    private setAssetLine(whichID:number) {
        var newAssetShape:number[] = [];
        var id = whichID;

        // for(var i:number=0; i<5; i++){
        //     newAssetShape.push(this.sectorObj.SectorPts[i][id]);
        // }
        newAssetShape.push(this.sectorObj.SectorPts[0].SectorCurveDA[id]);
        newAssetShape.push(this.sectorObj.SectorPts[0].SectorCurveDM[id]);
        newAssetShape.push(this.sectorObj.SectorPts[0].SectorCurveUC[id]);
        newAssetShape.push(this.sectorObj.SectorPts[0].SectorCurveUM[id]);
        newAssetShape.push(this.sectorObj.SectorPts[0].SectorCurveUA[id]);

        this.chart_legend_bond = this.sectorSelectedName;
        if(this.whichTRA == 2 || this.whichTRA == 3 || this.whichTRA == 4) {
            //idealLine.dataProvider = newAssetShape;
            this.chart_data_bond = newAssetShape;
        }
        //legend.redLegend.visible = true;
        //legend.bond.text = parent.parent.parent.sectorName[whichID];
    }

    public populateEndYield(names:string[], year:number, endGame:boolean):void
    {
        var curveArray:number[][] = this.yieldCurveArray;
        var nameArray:string[][] = this.YieldNameArray;
        var oldCurveArray:number[][] = this.yieldCurveArray;
        
        this.infoOverlay_chart_categoryNames = names;

        var whichYear = year;
        if(whichYear == 0){
            this.infoOverlay_chartData = [];
            //this.infoOverlay_chart_year1 = curveArray[0];
            this.infoOverlay_chart.push(curveArray[0]);

            /*if (endGame)*/ {
                this.infoOverlay_chart_legend[0] = "Start";
                this.infoOverlay_chart_legend[1] = "Year 1";
                //this.infoOverlay_chart_year2 = curveArray[1];
                this.infoOverlay_chart.push(curveArray[1]);
                //mcLegend.gotoAndStop(4);
            }/*else {
                this.infoOverlay_chart_legend[0] = "Year 1";
                //mcLegend.gotoAndStop(1);
            }*/
            for (var i:number = 0; i < 8; i++) {
                var calc = curveArray[1][i]-oldCurveArray[0][i];
                calc *= 100;
                calc = Math.round(calc);
                calc /= 100;
                
                var newChange = Number(oldCurveArray[0][i])+Number(calc);
                newChange *= 100;
                newChange = Math.round(newChange);
                newChange /= 100;

                var tempData: yearEndChart = {
                    Name: names[i],
                    Year0Value: curveArray[0][i].toString(),
                    Year0Change: calc.toString(),
                    Year1Value: newChange.toString(),
                    Year1Change: "-",
                    Year2Value: "-",
                    Year2Change: "-"
                };
                //console.log("**********");
                //console.log("**********");
                //console.log(tempData);
                //console.log("**********");
                //console.log("**********");
                this.infoOverlay_chartData.push(tempData);
                //this.infoOverlay_chart.push(curveArray[1]);
            }
        }
        else if(whichYear == 1){
            this.infoOverlay_chart_legend[2] = "Year 2"; //1] = "Year 2";
            console.log(curveArray[1]);
            //this.infoOverlay_chart_year2 = curveArray[1];
            this.infoOverlay_chart.push(curveArray[2]); //1]);

            for(var j:number = 0; j<8; j++){
                calc = curveArray[2][j]-oldCurveArray[1][j];
                calc *= 100;
                calc = Math.round(calc);
                calc /= 100;
                
                newChange = Number(oldCurveArray[1][j])+Number(calc);
                newChange *= 100;
                newChange = Math.round(newChange);
                newChange /= 100;

                this.infoOverlay_chartData[j].Year1Change = calc.toString();
                this.infoOverlay_chartData[j].Year2Value = newChange.toString();
            }

        }
        // //No longer using since now have "start"
        // else if(whichYear == 2){
        //     this.infoOverlay_chart_legend[3] = "Year 3"; //2]
        //     //this.infoOverlay_chart_year3 = curveArray[2];
        //     this.infoOverlay_chart.push(curveArray[3]); //2]);
        // }
        this._srvc.SetFooterData(this.infoOverlay_chartData, this.infoOverlay_chart_legend, this.infoOverlay_chart);
            
    }
    public setYourPerformance(bond:number, TRE:number, old:number, equity:number)
    {
        bond *= 100;
        bond = Math.round(bond);
        bond /= 100;
        
        TRE*= 100;
        TRE = Math.round(TRE);
        TRE /= 100;
        this.infoOverlay_performanceYours = {
            Bond: bond,
            TRE: TRE,
            From: old,
            NewEquity: equity,
            Diff: (equity - old)
        };
    }
    public setBankPerformance(bond:number, TRE:number, old:number, equity:number)
    {	
        bond *= 100;
        bond = Math.round(bond);
        bond /= 100;
        TRE*= 100;
        TRE = Math.round(TRE);
        TRE /= 100;

        this.infoOverlay_PerformanceBank = {
            Bond: bond,
            TRE: TRE,
            From: old,
            NewEquity: equity,
            Diff: (equity - old)
        };
    }

    public setYears(years:number, actualYear:string[], year:number, myTRA:number, bankTRA:number, percentile:number)
    {
        if(!myTRA) myTRA = 0;
        
        myTRA *= 100;
        myTRA = Math.round(myTRA) / 100; 
        
        bankTRA *= 100;
        bankTRA = Math.round(bankTRA) / 100; 
        
        percentile *= 100;
        percentile = Math.round(percentile) / 100; 
        
        this.endGameSummary.push({
            YearIndex: year + 1,
            YearActual: actualYear[year],
            MyBank: myTRA,
            TypicalBank: bankTRA,
            FiftiethPercent: percentile
        });
    }

    public loadFields(b:number, l:number, a:number, d:number, e:number) {
            this.currentGame_Assets_Bonds = b;
            this.currentGame_Assets_Loans = l;
            this.currentGame_Liabilities_Advances = a;
            this.currentGame_Liabilities_Deposits = d;
            this.currentGame_Equity_Liabilities = e;
            
            this.currentGame_Assets_Total = Number(b)+Number(l);
            this.currentGame_Liabilities_Total = Number(a)+Number(d);
            this.currentGame_Equity_Total = Number(e)+Number(a)+Number(d);
		}

}



// WEBPACK FOOTER //
// ./src/app/game/futureShape.ts